// removed by extract-text-webpack-plugin
module.exports = {"wind_rose_description":"wind_rose_description__3OP6Y"};


//////////////////
// WEBPACK FOOTER
// ./components/windrose/style.scss
// module id = zfcO
// module chunks = 13